<template>
  <div>
    <div class="bgColor mb10 p10">
      <div class="flex mb10" style="font-size:12px">
        <div class="mr20">
          当前供货商： <span class="primary">{{ row.storeName }}</span>
        </div>
        <div class="mr20">
          类型：{{ row.storeType === "supplier" ? "厂家" : "经销商" }}
        </div>
        <!-- <div class="mr20">总计下级经销商数<span class="primary">3</span>家</div> -->
      </div>
      <div class="flex flex-between item-center">
        <el-button type="primary" size="small" @click="add"
          >新增下级经销商</el-button
        >
        <div class="flex">
          <div @click="outputExcel" class="delete mr20 pointer" style="display: inline-block; font-size: 14px">
            <span class="delete-icon hmicon icon-daochu"></span>
            导出模板
          </div>
          <div class="delete mr20 pointer open-file" style="font-size: 14px; display: inline-block">
            <span class="delete-icon hmicon icon-daoru"></span>
            导入下级经销商
            <input
                type="file"
                @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
        </div>

      </div>
    </div>
    <hm-content title="">
      <div class="table">
        <el-table
          :data="list"
          style="width: 100%"
          stripe
          ref="treeTable"
          size="small"
          border
          lazy
          row-key="id"
          :load="load"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="left"
            label="名称"
            prop="agencyName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="left"
            label="授权区域"
            prop="categoryName"
          >
            <template slot-scope="scope">
              <div v-for="(v, i) in scope.row.areaList" :key="i">
                {{ v.provinceName
                }}<span v-if="v.cityName !== '-'">- {{ v.cityName }}</span>
                <span v-if="v.districtName !== '-'">-{{ v.districtName }}</span>
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--              header-align="center"-->
<!--              align="center"-->
<!--              label="经销商查看权限"-->
<!--              prop="categoryName"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <el-switch-->
<!--                  v-model="scope.row.lookDataFuncAuthFlag"-->
<!--                  active-color="#13ce66"-->
<!--                  @change="editCatAuthFlag(scope.row)"-->
<!--              >-->
<!--              </el-switch>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            header-align="center"
            align="center"
            label="授权系列"
            prop="categoryName"
          >
            <template slot-scope="scope">
              <span v-for="(v, i) in scope.row.seriesList" :key="i">
                <span v-if="i !== 0">、</span> {{ v.seriesName }}
              </span>
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="edit(scope.row)"
                  >编辑</el-button
                >
                <el-divider direction="vertical"></el-divider>
                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="del(scope.row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="新增经销商"
        width="1400px"
        :visible.sync="dialogVisible"
      >
        <div class="flex">
          <div style="width:400px">
            <div class="mb10 flex flex-end ">
              <el-input
                clearable
                v-model.trim="dealersName"
                placeholder="请输入经销商"
                size="small"
                class="ipt mr10"
              >
              </el-input>
              <el-button type="primary" size="small" @click="dealersSearch"
                >查询</el-button
              >
            </div>
            <div class="table">
              <el-table
                stripe
                ref="roleTable"
                :data="agencyList"
                style="width: 100%"
                id="table"
                size="small"
                border
                max-height="500"
                @selection-change="handleSelectiondealers"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  :index="
                    index =>
                      index + (dealersCurrentPage - 1) * dealersPageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="经销商"
                ></el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                background
                :pager-count="5"
                :total="dealersTotal"
                @current-change="dealersPaging"
                @size-change="dealersHandleSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="dealersCurrentPage"
              ></el-pagination>
            </div>
          </div>
          <div class="flex item-center">
            <el-button
              style="margin:20px"
              type="primary"
              size="small"
              @click="searchShop"
              >查询勾选经销商</el-button
            >
          </div>
          <div style="width:800px">
            <div class="mb10  flex flex-between ">
              <div>
                <span>批量设置授权:</span>
                <el-cascader
                  clearable
                  :disabled="!this.selectAgencyList.length"
                  class="mr10 "
                  v-model="batchSeriesList"
                  :props="querySeriesProps"
                  show-all-levels
                  filterable
                  size="small"
                  @change="batchSeriesListChange"
                  placeholder="请选择授权系列"
                >
                </el-cascader>
              </div>
              <div>
                <el-input
                  clearable
                  v-model.trim="shopName"
                  placeholder="请输入经销商名称"
                  size="small"
                  class="ipt mr10"
                >
                </el-input>
                <el-button type="primary" size="small" @click="shopNameChange"
                  >查询</el-button
                >
              </div>
            </div>
            <div class="table">
              <el-table
                stripe
                ref="roleTable"
                :data="searchShopList"
                style="width: 100%"
                id="table"
                size="small"
                border
                max-height="500"
                @selection-change="handleSelect"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  :index="
                    index => index + (shopCurrentPage - 1) * shopPageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="经销商"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="areaList"
                  label="授权区域"
                >
                  <template slot-scope="scope">
                    <el-cascader
                      clearable
                      class="mr10"
                      ref="cascader"
                      v-model="scope.row.areaList"
                      :props="queryProps"
                      :show-all-levels="false"
                      filterable
                      size="small"
                      placeholder="请选择收货地区"
                    >
                    </el-cascader>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopCounsst"
                  label="授权系列"
                >
                  <template slot-scope="scope">
                    <div class="dsda">
                      <el-cascader
                        clearable
                        class="mr10 "
                        :ref="'cascaders' + scope.$index"
                        v-model="scope.row.seriesList"
                        :props="querySeriesProps"
                        show-all-levels
                        filterable
                        size="small"
                        @change="seriesListChange(scope.$index)"
                        placeholder="请选择授权系列"
                      >
                      </el-cascader>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div class="hm-pagination">
                <el-pagination
                  background
                  :total="shopTotal"
                  @current-change="shopPaging"
                  @size-change="shopHandleSizeChange"
                  layout="total,sizes, prev, pager, next, jumper"
                  :current-page="shopCurrentPage"
                ></el-pagination>
              </div> -->
            </div>
          </div>
        </div>
        <div slot="footer" class=" flex flex-center">
          <el-button size="small" type="primary" @click="save">确 定</el-button>
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="新增失败的经销商"
        width="600px"
        :visible.sync="errdialogVisible"
      >
        <div class="form-red">
          失败原因：该经销商有可能已经是下级或者上级，导致新增失败
        </div>
        <el-table
          stripe
          ref="roleTable"
          :data="errList"
          style="width: 100%"
          id="table"
          size="small"
          border
          max-height="500"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="经销商"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="增加授权系列"
        :visible.sync="dialogVisibleseries"
      >
        <div v-if="dialogVisibleseries">
          <el-cascader
            clearable
            class="mr10 "
            v-model="seriesArr"
            :props="querySeriesEditProps"
            @change="seriesArrChange"
            show-all-levels
            filterable
            size="small"
            placeholder="请选择授权系列"
          >
          </el-cascader>
        </div>
        <div slot="footer" class=" flex flex-center">
          <el-button size="small" type="primary" @click="editSave"
            >确 定</el-button
          >
          <el-button size="small" @click="dialogVisibleseries = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>
      <el-dialog :visible.sync="errValidImport" title="导入下级经销商" :close-on-click-modal="false" width="600px">
        <div class="flex flex-center">
          <div class="text-center">
            <span style="font-size: 50px;"  class="hmicon icon-tishi1 orange"></span>
          </div>
        </div>
        <div class="flex flex-center mt10">
          <span style="font-size: 18px" class="orange">有{{errInputResult.length}}个经销商无法导入</span>
        </div>
        <div style="margin-top: 50px" >
          <el-table :data="errInputResult" border class="small-table">
            <el-table-column prop="agencyName" header-align="center" align="center" label="经销商名称"></el-table-column>
            <el-table-column prop="errorMsg" header-align="center" align="center" label="失败原因"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer flex flex-center">
          <el-button  type="primary" @click="errValidImport = false">关闭</el-button>
        </div>
      </el-dialog>
    </hm-content>
  </div>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  data() {
    return {
      seriesArr: [],
      dialogVisibleseries: false,
      errdialogVisible: false,
      batchSeriesList: [],
      changeOnSelect: false,
      queryProps: {
        lazy: true,
        checkStrictly: true,
        multiple: true,
        value: "code",
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store.dispatch("queryRegionCode").then(res => {
              res.result.forEach(v => {
                // v.disabled = true;
                v.code = JSON.stringify({
                  level: v.level,
                  provinceName: v.label,
                  provinceCode: v.value
                });
                // v.leaf = Boolean(!v.isParent);
                // v.value = v.orgCode;
                // v.label = v.departName;
              });
              resolve(res.result);
            });
          } else {
            this.$store
              .dispatch("queryRegionCode", {
                value: data.value,
                level
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = v.level === "3" ? true : false;
                    if (v.level === "2") {
                      v.code = JSON.stringify({
                        provinceName: data.label,
                        provinceCode: data.value,
                        level: v.level,
                        cityName: v.label,
                        cityCode: v.value
                      });
                    } else if (v.level === "3") {
                      v.code = JSON.stringify(
                        Object.assign(JSON.parse(data.code), {
                          level: v.level,
                          districtName: v.label,
                          districtCode: v.value
                        })
                      );
                    }
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      querySeriesProps: {
        lazy: true,
        checkStrictly: true,
        multiple: true,
        value: "code",
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("querySupplierAgencyRelBrandList", {
                supplierCode: this.row.storeCode
              })
              .then(res => {
                res.result.records.forEach(v => {
                  // v.disabled = true;
                  // v.code = v.value;
                  v.leaf = false;
                  v.code = {
                    brandName: v.brandName,
                    brandId: v.brandId
                  };
                  v.label = v.brandName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("querySupplierAgencyRelSeriesList", {
                brandId: data.code.brandId,
                parentCode: this.row.storeCode,
                level
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = true;
                    v.code = {
                      brandId: data.brandId,
                      brandName: data.label,
                      seriesId: v.seriesId,
                      seriesName: v.seriesName
                    };
                    v.label = v.seriesName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      querySeriesEditProps: {
        lazy: true,
        checkStrictly: true,
        multiple: true,
        value: "code",
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("querySupplierAgencyRelBrandList", {
                supplierCode:
                  this.currentRow.level === 1
                    ? this.row.storeCode
                    : this.currentRow.parentCode
              })
              .then(res => {
                res.result.records.forEach(v => {
                  // v.disabled = true;
                  // v.code = v.value;
                  v.leaf = false;
                  v.code = {
                    brandName: v.brandName,
                    brandId: v.brandId
                  };
                  v.label = v.brandName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("querySupplierAgencyRelSeriesList", {
                brandId: data.code.brandId,
                parentCode: this.row.storeCode,
                level
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = true;
                    v.code = {
                      brandId: data.brandId,
                      brandName: data.label,
                      seriesId: v.seriesId,
                      seriesName: v.seriesName
                    };
                    v.label = v.seriesName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      queryAreaCodeRegion: [],
      row: {},
      shopTotal: 0,
      shopCurrentPage: 1,
      shopPageSize: 10,
      shopList: [],
      dealersName: "",
      shopName: "",
      agencyList: [],
      dealersCurrentPage: 1,
      dealersPageSize: 10,
      dealersTotal: 0,
      dialogVisible: false,
      checkedRow: [],
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      type: "",
      storeCodeList: [],
      selectAgencyList: [],
      errList: [],
      searchShopList: [],
      currentRow: {},
      tBody: ["agencyName","province","city","district","seriesNames"],
      tHeader: ["下级经销商【必填】","授权省","授权市","授权区","授权品牌及系列（多个\",\"隔开,如：飞鹤_星飞帆,飞鹤_星阶优选）【必填】"],
      errValidImport: false,
      errInputResult: [],
    };
  },
  created() {},
  mounted() {
    this.row = JSON.parse(this.$route.query.rows);
    console.log("row", this.row);
    this.queryList();
  },
  methods: {
    async editCatAuthFlag(row) {
      row.lookDataFuncAuthFlag = !row.lookDataFuncAuthFlag;
      let params = {
        lookDataFuncAuthFlag: !row.lookDataFuncAuthFlag,
        agencyCode: row.agencyCode,
        parentCode: row.parentCode
      };
      await this.$store.dispatch("editAgencyFuncAuth", params);
      this.$message({
        message: "操作成功！",
        type: "success"
      });

      this.$nextTick(() => {
        this.list = [];
        this.queryList();
      });
    },
    //导出模板
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        exportJsonToExcel(
            this.tHeader,
            [[]],
            "导入下级经销商模板" + new Date().toLocaleString()
        );
      });
    },
    //导入下级经销商
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = {};
        let formatResultDataList = [];
        console.log("row===>",that.row);
        formatResult.parentCode = that.row.storeCode;
        formatResult.parentName = that.row.storeName;

        result.map((v, i) => {
          formatResultDataList.push({});
          that.tBody.map((o, index) => {
            formatResultDataList[i][that.tBody[index]] = v[index] ? (v[index] + "").replace(/\s*/g, "") : "";
          });
        });
        formatResult.agencyList = formatResultDataList;
        console.log("formatResult==>",formatResult);

        that.$store
            .dispatch("batchSaveAgency", formatResult)
            .then(res => {
              const { code, result } = res;
              console.log("result: ", result);
              if (code === "0") {
                if (result && result.length > 0) {
                  that.errInputResult = result;
                  that.errValidImport = true;
                }
                that.queryList();
              }
            });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    shopNameChange() {
      this.searchStoreName();
    },
    searchStoreName() {
      this.searchShopList = this.shopList.filter(
        data =>
          !this.shopName ||
          data.storeName.toLowerCase().includes(this.shopName.toLowerCase())
      );
    },
    async editSave() {
      let index = this.seriesArr.findIndex(v => v.length < 2);
      if (index > -1) {
        this.$message({
          message: `请选择${this.seriesArr[index][0].brandName} 品牌下系列!`,
          type: "warning"
        });
        return;
      }
      let seriesList = [];
      this.seriesArr.forEach(j => {
        if (j.length > 1) {
          seriesList.push(j[j.length - 1]);
        }
      });
      seriesList.push(...this.currentRow.seriesList);
      let params = {
        seriesList,
        id: this.currentRow.id
      };
      await this.$store.dispatch("editSupplierAgencyRelSeriesList", params);
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.dialogVisibleseries = false;
      this.list = [];
      this.seriesArr = [];
      this.queryList();
    },
    edit(row) {
      this.currentRow = row;
      this.dialogVisibleseries = true;
    },
    async save() {
      if (this.selectAgencyList.length) {
        let flagNum = this.selectAgencyList.findIndex(
          v => v.areaList.length === 0
        );
        let flagSeriesNum = this.selectAgencyList.findIndex(
          v => v.seriesList.length === 0
        );

        if (flagNum > -1) {
          this.$message({
            message: `${this.selectAgencyList[flagNum].storeName}没有选择授权区域！`,
            type: "warning"
          });
          return;
        }
        if (flagSeriesNum > -1) {
          this.$message({
            message: `${this.selectAgencyList[flagNum].storeName}没有选择系列！`,
            type: "warning"
          });
          return;
        }
        let agencyList = JSON.parse(JSON.stringify(this.selectAgencyList));

        // let flagNum = this.selectAgencyList.findIndex(
        //   v => v.areaList.length === 0
        // );
        let falg = false;
        agencyList.forEach(v => {
          let areaList = [];
          v.areaList.forEach(j => {
            areaList.push(JSON.parse(j[j.length - 1]));
          });
          v.areaList = areaList;
          let seriesList = [];
          v.seriesList.forEach(j => {
            if (j.length > 1) {
              seriesList.push(j[j.length - 1]);
            }
          });
          if (!seriesList.length) {
            falg = true;
          }
          v.seriesList = seriesList;
        });
        if (falg) {
          this.$message({
            message: "请选择品牌下系列！",
            type: "warning"
          });
          return;
        }

        let params = {
          parentCode: this.row.storeCode,
          parentName: this.row.storeName,
          agencyList
        };
        const { result } = await this.$store.dispatch(
          "addSupplierAgencyRelSeriesList",
          params
        );
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        if (result.length) {
          this.errList = result;
          this.errdialogVisible = true;
        }
        this.reset();
        this.queryList();
        this.dialogVisible = false;
      } else {
        this.$message({
          message: "请选择需要保存的经销商！",
          type: "warning"
        });
      }
    },

    reset() {
      this.shopList = [];
      this.searchShopList = [];
      this.batchSeriesList = [];
      this.selectAgencyList = [];
    },
    seriesArrChange(val) {
      let index = val.findIndex(v => v.length < 2);
      if (index > -1) {
        this.$message({
          message: `请选择${val[index][0].brandName} 品牌下系列!`,
          type: "warning"
        });
        return;
      }
    },
    batchSeriesListChange(val) {
      if (this.selectAgencyList.length) {
        let index = val.findIndex(v => v.length < 2);
        if (index > -1) {
          this.$message({
            message: `请选择${val[index][0].brandName} 品牌下系列!`,
            type: "warning"
          });
          return;
        }
        let textList = [];
        val.forEach(v => {
          textList.push(v[1].seriesName);
        });
        this.searchShopList.forEach((v, i) => {
          if (v.checked) {
            setTimeout(() => {
              this.$refs["cascaders" + i].presentText = textList.join(",");
            }, 0);
          }
        });
        this.selectAgencyList.forEach(v => {
          v.seriesList = val;
        });
      } else {
        this.$message({
          message: "请选择经销商！",
          type: "warning"
        });
      }
    },
    seriesListChange(i) {
      let index = this.searchShopList[i].seriesList.findIndex(
        v => v.length < 2
      );
      if (index > -1) {
        this.$message({
          message: `请选择${this.searchShopList[i].seriesList[index][0].brandName} 品牌下系列!`,
          type: "warning"
        });
      }
      // this.shopList[i].seriesList.splice(index, 1);
      // console.log("val: ", this.shopList[i]);
    },
    async queryAgencyList() {
      let params = {
        pageSize: this.dealersPageSize,
        pageNo: this.dealersCurrentPage,
        storeType: "agency",
        keyWords: this.dealersName
      };

      const { code, result } = await this.$store.dispatch(
        "querySupplierBasicList",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        records.forEach(v => {
          v.areaList = [];
          v.seriesList = [];
          v.agencyCode = v.storeCode;
          v.agencyName = v.storeName;
        });
        this.agencyList = records;
        this.dealersTotal = total;
        this.removal();
      }
    },
    add() {
      this.type = "add";
      this.dialogVisible = true;
      this.queryAgencyList();
    },
    searchShop() {
      if (this.storeCodeList.length) {
        // this.shopCurrentPage = 1;
        // this.queryShopList();
        this.shopList.push(...this.storeCodeList);
        this.shopList = arrayUnique2(this.searchShopList, "agencyCode");
        this.searchShopList = this.shopList;
        this.removal();
      } else {
        this.$message({
          message: "请选择经销商",
          type: "warning"
        });
      }
    },
    //清除已选择项
    removal() {
      this.searchShopList.forEach(v => {
        this.agencyList.forEach((item, i) => {
          if (v.agencyCode === item.agencyCode) {
            this.agencyList.splice(i, 1);
          }
        });
      });
    },
    shopPaging(page) {
      this.shopCurrentPage = page;
      this.queryShopList();
    },
    shopHandleSizeChange(size) {
      this.shopCurrentPage = 1;
      this.shopPageSize = size;
      this.queryShopList();
    },
    dealersSearch() {
      this.dealersCurrentPage = 1;
      this.queryAgencyList();
    },
    load(tree, treeNode, resolve) {
      let seriesIdList = [];
      tree.seriesList.forEach(v => {
        seriesIdList.push(v.seriesId);
      });
      this.id = tree.id;
      // this.categoryLevel = tree.categoryLevel;
      // const { categoryLevel, categoryId } = tree;
      resolve([]);
      // if (this.no === 1) {
      this.$store
        .dispatch("supplierAgencyRelList", {
          parentCode: tree.agencyCode,
          seriesIdList,
          pageNo: 1,
          pageSize: 999
        })
        .then(res => {
          if (res.code === "0" && res.result.records.length) {
            res.result.records.forEach(v => {
              v.hasChildren = true;
            });
            resolve(res.result.records);
          } else {
            resolve([]);
          }
        });
    },
    dealersPaging(page) {
      this.storeCurrentPage = page;
      this.queryAgencyList();
    },
    dealersHandleSizeChange(size) {
      this.storeCurrentPage = 1;
      this.storePageSize = size;
      this.queryAgencyList();
    },
    handleSelect(selection) {
      if (selection.length) {
        selection.forEach(v => (v.checked = true));
      } else {
        selection.forEach(v => (v.checked = false));
      }

      this.selectAgencyList = selection;
    },
    handleSelectiondealers(selection) {
      this.storeCodeList = selection;
    },
    handleSelectionChange(selection) {
      this.checkedRow = selection;
    },
    async del(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("removActivePlanRel", {
          id: row.id
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      }
    },
    async queryList() {
      const params = {
        parentCode: this.$route.query.storeCode,
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "supplierAgencyRelList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        records.forEach(v => {
          v.level = 1;
          v.hasChildren = true;
        });
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss">
/* 设置下拉框中，隐藏第1级的勾选，设置第2级点击label就可以选中 */
// .el-cascader__dropdown
//   .el-cascader-menu:nth-of-type(1)
//   .el-cascader-node
//   label {
//   display: none;
// }
// .el-cascader-panel .el-cascader-menu:nth-of-type(2) .el-checkbox {
//   width: 100%;
// }
// .el-cascader-panel .el-cascader-menu:nth-of-type(2) .el-cascader-node__label {
//   margin-left: -90%;
// }
</style>
<style scoped lang="scss"></style>
